import Footer from "@/components/Footer";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-[#0a0908] text-[#F7F4EE]" data-testid="cookies-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <span className="av-eyebrow">Documento legale</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-[1.05]">
          Cookie <span className="italic text-[#E5A93C]">Policy</span>
        </h1>
        <p className="text-[#A39E93] mt-4 text-sm">
          Ultimo aggiornamento: 19 settembre 2026 · Redatta ai sensi del{" "}
          <strong>Provvedimento Garante 10 giugno 2021 n. 231</strong> e delle
          Linee Guida Cookie EDPB 03/2022.
        </p>

        <div className="mt-10 space-y-6 text-[#F7F4EE]/90 leading-relaxed">
          <p>
            Il portale <strong>NMA Agency</strong> utilizza cookie e tecnologie
            simili (localStorage, sessionStorage) per garantire il corretto
            funzionamento del sito, migliorare l'esperienza utente e — solo
            previo consenso — per finalità analitiche e di embed social.
          </p>

          <h2 className="font-serif-display text-2xl text-[#E5A93C] mt-8">
            Tipologie di cookie utilizzati
          </h2>

          <div className="av-card p-5" data-testid="cookies-technical">
            <h3 className="font-serif-display text-xl">
              1 · Cookie tecnici e di sessione
            </h3>
            <p className="text-sm text-[#A39E93] mt-1">
              <strong>Base giuridica:</strong> legittimo interesse — non
              richiedono consenso.
            </p>
            <p className="mt-3 text-sm">
              Necessari per il funzionamento del portale (autenticazione, chat,
              carrello eventi, preferenze lingua). Durata: dalla sessione fino a
              30 giorni.
            </p>
            <ul className="list-disc pl-5 mt-2 text-xs text-[#A39E93]">
              <li><code className="text-[#E5A93C]">av_token</code> — token JWT di autenticazione (30 giorni)</li>
              <li><code className="text-[#E5A93C]">av_lang</code> — lingua selezionata IT/EN</li>
              <li><code className="text-[#E5A93C]">event_cart</code> — carrello eventi</li>
              <li><code className="text-[#E5A93C]">av_cookie_consent</code> — memorizzazione scelta cookie</li>
            </ul>
          </div>

          <div className="av-card p-5" data-testid="cookies-analytics">
            <h3 className="font-serif-display text-xl">
              2 · Cookie analitici anonimi
            </h3>
            <p className="text-sm text-[#A39E93] mt-1">
              <strong>Base giuridica:</strong> legittimo interesse — dati
              aggregati e anonimizzati, esenti da consenso ai sensi delle Linee
              Guida Garante 2021.
            </p>
            <p className="mt-3 text-sm">
              NMA rileva pagine visitate, referer, timestamp e IP{" "}
              <em>troncato</em> unicamente per statistiche interne (contatore
              visite admin). Nessun dato è trasmesso a terze parti.
            </p>
          </div>

          <div className="av-card p-5" data-testid="cookies-third-party">
            <h3 className="font-serif-display text-xl">
              3 · Cookie di terze parti (embed social)
            </h3>
            <p className="text-sm text-[#A39E93] mt-1">
              <strong>Base giuridica:</strong> consenso esplicito dell'utente.
            </p>
            <p className="mt-3 text-sm">
              Se acconsenti, la home mostra widget di terze parti che possono
              installare i propri cookie:
            </p>
            <ul className="list-disc pl-5 mt-2 text-xs space-y-1">
              <li>
                <strong>Facebook Page Plugin</strong> — feed della pagina NMA
                Agency. Privacy:{" "}
                <a
                  href="https://www.facebook.com/privacy/policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#E5A93C] underline"
                >
                  facebook.com/privacy/policy
                </a>
              </li>
              <li>
                <strong>YouTube (youtube-nocookie.com)</strong> — player video
                embedded in modalità "no-cookie enhanced privacy". Privacy:{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#E5A93C] underline"
                >
                  policies.google.com/privacy
                </a>
              </li>
              <li>
                <strong>Stripe Checkout</strong> — solo durante il pagamento.
                Privacy:{" "}
                <a
                  href="https://stripe.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#E5A93C] underline"
                >
                  stripe.com/privacy
                </a>
              </li>
            </ul>
            <p className="mt-3 text-xs text-[#A39E93]">
              Se rifiuti, gli embed vengono sostituiti con card statiche prive
              di script di terze parti.
            </p>
          </div>

          <h2 className="font-serif-display text-2xl text-[#E5A93C] mt-8">
            Come gestire i cookie
          </h2>
          <p className="text-sm">
            Puoi modificare in qualsiasi momento le tue preferenze cliccando sul
            pulsante qui sotto (revoca o cambio del consenso senza pregiudicare
            la liceità del trattamento pregresso, art. 7.3 GDPR):
          </p>
          <button
            onClick={() => {
              try {
                localStorage.removeItem("av_cookie_consent");
                window.location.reload();
              } catch (err) {
                console.warn("[cookies] failed to reset consent", err?.message || err);
              }
            }}
            className="av-pill av-pill-gold mt-3"
            data-testid="reset-cookie-consent"
          >
            Rivedi / Revoca il consenso cookie
          </button>

          <p className="text-sm mt-6">
            In alternativa puoi bloccare o cancellare i cookie direttamente dal
            tuo browser:
          </p>
          <ul className="list-disc pl-6 text-xs text-[#A39E93] space-y-1">
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E5A93C] underline"
              >
                Google Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E5A93C] underline"
              >
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E5A93C] underline"
              >
                Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.microsoft.com/it-it/microsoft-edge"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E5A93C] underline"
              >
                Microsoft Edge
              </a>
            </li>
          </ul>
        </div>
      </section>
      <Footer />
    </div>
  );
}
